// config.js
import axios from 'axios'
const service = axios.create({
  baseURL: 'http://bigdata_api.beikunit.com/api/Content',//Api请求默认前缀
  //baseURL: 'http://localhost:5000/api/Content'
})
//请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求发出之前可以对config做一些修改，例如添加请求头信息
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)
//相应拦截器
service.interceptors.response.use(
  response => {
    // 在响应返回之前可以对response做一些修改，例如解析响应数据
    return response.data
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

export default service